import { createStyles, Theme } from '@nelnet/unifi-components-react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const styles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    sideMargins: {
      padding: `${spacing(0)}px ${spacing(2)}px ${spacing(0)}px`,
      [breakpoints.up('lg')]: {
        padding: `${spacing(0)}px 250px ${spacing(0)}px`,
      },
    },
    image: {
      height: '150px',
      width: '150px',
      paddingTop: '2rem',
    },
    hideShowDisplay: {
      display: 'none',
      [breakpoints.up('md')]: {
        display: 'flex',
        justifyContent: 'space-around',
      },
    },
    contentWithImage: {
      padding: '0 2rem',
      [breakpoints.up('lg')]: {
        padding: '0 6rem',
      },
    },
  });

export default styles;
